module.exports = "https://static.energy5.com/_next/static/images/secondStepHIWImage-8296a5af40b0cfec44979092480e7f15.jpg";